import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import AccessProfileAction from '../app/store/actions/accessProfiles';
import ModalComponent from '../components/modal';

import NumbersHelper from '../helpers/numbers';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class AccessProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'id',
      showModal: false,
      show: false,
    };
  }

  componentDidMount() {
    this.searchAccessProfile();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchAccessProfile();
  }

  searchAccessProfile = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, search, false, orderBy, field);
  }

  activeAccessProfile = async (id, status) => {
    await this.props.activeAccessProfile(id, status);
    await this.searchAccessProfile();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchAccessProfile();
  }

  deleteProfileModal = async (profileId) => {
    await this.setState({ selectItemToDelete: profileId, showModal: true });
  }

  deleteAccessProfile = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deleteAccessProfile(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchAccessProfile();
      this.deleteNotification();
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  render() {
    const { limit, page, showModal } = this.state;
    const { accessProfiles = {}, } = this.props;

    const tableHeader = [
      { key: 'id', value: I18n.t('ID') },
      { key: 'profile', value: I18n.t('profile') },
      { key: 'description', value: I18n.t('description') },
      { key: 'action', value: I18n.t('action') },
    ];
    const tableData = (accessProfiles.rows || []).map((row, index) => ({
      key: index,
      id: row.id,
      profile: row.profile,
      description: row.description,
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${row.status === 'active' ? 'warning' : 'dark'} promotion-btn-${
              row.status === 'active' ? 'warning' : 'active'}`}
            onClick={() => this.activeAccessProfile(row.profileId, row.status === 'active' ? 'inactive' : 'active')}
          >
            <Translate value={row.status === 'active' ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                onClick={() => history.push({
                  pathname: ROUTES.ACCESS_PROFILE_CONFIG,
                  screenComming: 'profile',
                  search: `?id=${row.id}`,
                })}
                className="dropdown-item dropdown-table"
              >
                <Translate value="permissions" />
              </button>

              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => history.push({
                  pathname: ROUTES.ACCESS_PROFILE_FORM,
                  screenComming: 'profile',
                  search: `?id=${row.id}`,
                })}
              >
                <Translate value="edit" />
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteProfileModal(row.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.ACCESS_PROFILE_FORM, screenComming: 'profile' }} />

        <button
          onClick={() => this.props.getCsvAccessProfileReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body="Deseja realmente excluir o banner?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteAccessProfile}
        />

        <Table
          title={I18n.t('accessProfiles')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={accessProfiles && accessProfiles.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  activeAccessProfile: (profileId, status) => dispatch(AccessProfileAction.updateAccessProfile({ profileId, status })),
  searchItems: (limit, skip, search, force, order, field) => dispatch(
    AccessProfileAction.getAccessProfiles(limit, skip, search, force, order, field),
  ),
  deleteAccessProfile: id => dispatch(AccessProfileAction.deleteAccessProfile(id)),
  getCsvAccessProfileReport: () => dispatch(AccessProfileAction.getCsvAccessProfileReport()),
});

const mapStateToProps = state => ({
  accessProfiles: state.accessProfiles.accessProfiles,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessProfilePage);
